





















































































































import Vue from "vue";
import { mapActions, mapState, mapGetters } from "vuex";
import { User, getErrorMsg } from "@/types";
import { get, post } from "@/api";
import { Form, CustomRenderers } from "@canvas/vuejsonschemaform";
import { renderObjectAsAddressForm } from "../Renderers";
import { AInput, Dropdown } from "@canvas/componentlibrary";
import {
  emailRegex,
  MARKETING_LEAD_SOURCE_RFFERAL,
  MARKETING_LEAD_SOURCE,
  MARKETING_LEAD_MEDIUM,
} from "../../consts";
import { debounce } from "@/utils";

export default Vue.extend({
  components: {
    Form,
    Dropdown,
    AInput,
  },
  data(): { [key: string]: any } {
    return {
      basicDetailFormStructure: {},
      isProjectAlreadyExist: false,
      isUserDisabled: false,
      saveBtn: {
        isDisabled: false,
        text: "Next",
      },
      modalElement: {
        isVisible: false,
        isClosable: false,
        title: "",
        type: "",
        content: "",
      },
      refferalOptions: [
        { name: "Yes", display_name: "Yes" },
        { name: "No", display_name: "No" },
      ],
      isRefferal: "",
      refereeName: "",
      refereeEmail: "",
      validateStatus: {
        isRefferal: "",
        refereeName: "",
        refereeEmail: "",
        refereePhone: "",
      },
      refereePhone: {
        countryCode: 0,
        value: "",
        phoneNumber: "",
      },
    };
  },
  computed: {
    ...mapState("appModule", {
      projects: "projects",
      selectedEc: "selectedEc",
      countryCode: "countryCode",
      config: "config",
      sessionToken: "sessionToken",
    }),
    initialPhoneOptions(): Record<string, any> {
      return {
        initialCountry: (this as any).countryCode,
      };
    },
    phoneInitialOptions(): Record<string, any> {
      let options = {
        number: (this as any).refereePhone.value,
        initialisationOptions: (this as any).initialPhoneOptions,
      };
      return options;
    },
    isReferralSupported() {
      if (
        (this as any).config &&
        (this as any).config.countriesSupportingReferral
      ) {
        return (this as any).config.countriesSupportingReferral
          .map((country: string) => country.toLowerCase())
          .includes((this as any).countryCode.toLowerCase());
      }
      return false;
    },
    renderers() {
      const designBriefRenders = {
        address: renderObjectAsAddressForm,
      };
      (CustomRenderers["*"] as any) = {
        ...CustomRenderers["*"],
        ...designBriefRenders,
      };
      return CustomRenderers;
    },
  },
  methods: {
    ...mapActions("appModule", ["getFormStructureSchema"]),
    ...mapActions("appModule", [
      "createLead",
      "getProjects",
      "getEcInfoOfUser",
    ]),
    validatePhone(value: { number: string | number; country: string }) {
      (this as any).validateStatus.refereePhone = "validating";
      (this as any).refereePhone.value = value.number as string;
      debounce(() => {
        if (value.number != "") {
          const query =
            "phone=" +
            value.number +
            "&iso-code=" +
            value.country +
            "&format=international";
          return get({ endpoint: "webbackend.v1.phone.validate", query })
            .then((response: { phone: string; country_code: number }) => {
              (this as any).validateStatus.refereePhone = "success";
              (this as any).refereePhone.countryCode = response.country_code;
              (this as any).refereePhone.phoneNumber = response.phone;
            })
            .catch((err: any) => {
              (this as any).validateStatus.refereePhone = "error";
            });
        } else {
          (this as any).validateStatus.refereePhone = "success";
        }
      }, 500)();
    },
    goToProjects() {
      (this as any).$router.push({
        path: "/search/" + (this as any).projectSearchQueryString + "/projects",
      });
    },
    getResource(url: string, data?: any) {
      // TODO: Needs more thinking for configurability with compile time saftey
      if (url.startsWith("webbackend/v1/phone/validate")) {
        const query = url.split("?")[1];
        return get({ endpoint: "webbackend.v1.phone.validate", query })
          .then((response: { phone: string; country_code: number }) => {
            return response;
          })
          .catch((err: any) => {
            throw new Error(err);
          });
      } else if (url.startsWith("webbackend/v3/places/autocomplete")) {
        const query = url.split("?")[1];
        return get({
          endpoint: "webbackend.v3.places.autocomplete.:query",
          query,
          country_code: (this as any).countryCode,
          session_token: (this as any).sessionToken,
        })
          .then((response: any) => {
            return response.map(
              (place: { placeId: string; description: string }) => ({
                placeId: place.placeId,
                name: place.placeId,
                display_name: place.description,
              })
            );
          })
          .catch((err: any) => {
            (this as any).$store.dispatch("uiModule/addToast", {
              severity: "error",
              message: getErrorMsg(err),
            });
            throw new Error(err);
          });
      } else if (url.startsWith("daakiya/api/v1/places/placeId")) {
        (this as any).$store.commit("uiModule/showLoadingModal", null, {
          root: true,
        });
        const place_id = url.split("?")[1];
        return get({
          endpoint: "daakiya.api.v1.places.:placeId",
          place_id: place_id,
        })
          .then((response: any) => {
            (this as any).$store.commit("uiModule/hideLoadingModal", null, {
              root: true,
            });
            return response;
          })
          .catch((err: any) => {
            (this as any).$store.commit("uiModule/hideLoadingModal", null, {
              root: true,
            });
            (this as any).$store.dispatch("uiModule/addToast", {
              severity: "error",
              message: getErrorMsg(err),
            });
            throw new Error(err);
          });
      } else if (url.startsWith("daakiya/api/v1/pincode/search")) {
        (this as any).$store.commit("uiModule/showLoadingModal", null, {
          root: true,
        });
        return post({
          endpoint: "daakiya.api.v1.pincode.search",
          body: { pincodes: data, serviceable: true },
        })
          .then((response: any) => {
            (this as any).$store.commit("uiModule/hideLoadingModal", null, {
              root: true,
            });
            return response;
          })
          .catch((err: any) => {
            (this as any).$store.commit("uiModule/hideLoadingModal", null, {
              root: true,
            });
            (this as any).$store.dispatch("uiModule/addToast", {
              severity: "error",
              message: getErrorMsg(err),
            });
            throw new Error(err);
          });
      } else {
        throw new Error("Unrecognized url");
      }
    },
    goToNextStep() {
      let resPromise: Promise<any> | undefined;
      resPromise = (this as any).handleWithDecorationAction(
        (this as any).createNewLead,
        (this as any).saveBtn
      );
      if (resPromise) {
        //Need to check why this wasn't working and I had to add ctx here
        let ctx = this;
        resPromise
          .then((response: any) => {
            (this as any).$router.push({
              path: "/lead/" + response.id + "/details",
            });
            //move to next step
          })
          .catch((err: any) => {});
      }
    },
    actionOnFormChanges(event: { type: string; data: string }) {
      (this as any).isProjectAlreadyExist = false;
      let searchKey: "customer_email" | "customer_phone" | null = null;
      if (event.type === "phone") {
        searchKey = "customer_phone";
      } else if (event.type === "email") {
        searchKey = "customer_email";
      }
      (this as any).projectSearchQueryString =
        searchKey + ":" + event.data.replace(/\s/g, "");
      if (searchKey) {
        let projects;
        (this as any)
          .getProjects({
            query: (this as any).projectSearchQueryString,
            showLoader: false,
          })
          .then((response: any) => {
            projects = response;
            if (projects.length > 0) {
              (this as any).isProjectAlreadyExist = true;
              (this as any).modalElement = {
                isVisible: true,
                isClosable: true,
                title: "Alert !!",
                type: "showmessage",
                content: "Projects Already Exists for user.",
              };
            }
          });
      }
    },
    updateReason(item: any) {
      (this as any).isRefferal = item;
      (this as any).validateStatus.isRefferal = "success";
    },
    handleInput(event: any, input: string) {
      (this as any)[input] = event;
      if (input === "refereeEmail") {
        (this as any).validateStatus.refereeEmail = emailRegex.test(
          event.toLowerCase()
        )
          ? "success"
          : "error";
      } else if (input === "refereeName") {
        (this as any).validateStatus.refereeName = (this as any)[input]
          ? "success"
          : "error";
      }
    },
    hasValidationError() {
      return Object.values((this as any).validateStatus).some(
        (status) => status === "error"
      );
    },
    clearValidationStatus() {
      (this as any).validateStatus = {
        isRefferal: "",
        refereeName: "",
        refereeEmail: "",
        refereePhone: (this as any).validateStatus.refereePhone,
      };
    },
    validateField(fieldName: string, isReferralField = false) {
      isReferralField
        ? (this as any).validateInputRefferal(fieldName)
        : (this as any).validateInput(fieldName);
    },
    validateInput(field: any) {
      if ((this as any)[field] && (this as any)[field].name) {
        (this as any).validateStatus[field] = "success";
      } else {
        (this as any).validateStatus[field] = "error";
      }
    },
    validateInputRefferal(field: any) {
      (this as any).validateStatus[field] = (this as any)[field]
        ? "success"
        : "error";
    },
    validatePhoneField(field: any) {
      (this as any).validateStatus[field] =
        (this as any).validateStatus[field] || "error";
    },
    createNewLead() {
      (this as any).clearValidationStatus();
      if ((this as any).isReferralSupported) {
        (this as any).validateField("isRefferal");
        if ((this as any).isRefferal.name === "Yes") {
          (this as any).validateField("refereeName", true);
          // (this as any).validateField("refereeEmail", true);
          (this as any).validatePhoneField("refereePhone");
        }
      }

      const formdata_basic = ((this as any).$refs.form1 as Form).getFormData();
      if ((this as any).hasValidationError()) {
        return;
      }

      if (formdata_basic) {
        //move formdata validation to another function
        formdata_basic.pincode = formdata_basic.site_address.pincode;
        formdata_basic.resolve_city = true;
        formdata_basic.marketing_lead_medium = MARKETING_LEAD_MEDIUM;
        formdata_basic.marketing_lead_source =
          (this as any).isRefferal.name === "Yes"
            ? MARKETING_LEAD_SOURCE_RFFERAL
            : MARKETING_LEAD_SOURCE;
        formdata_basic.marketing_lead_channel = (this as any).selectedEc.display_name;

        if ((this as any).isRefferal.name === "Yes") {
          formdata_basic.referee_name = (this as any).refereeName;
          formdata_basic.referee_email = (this as any).refereePhone.phoneNumber;
          (this as any).$store.commit("appModule/storeRefereeDetails", {
            referee_name: (this as any).refereeName,
            referee_phone: (this as any).refereePhone.phoneNumber,
          });
        }
        //keep current address and site address in store
        const site_address = {
          address_type: "site_address",
          place_id: formdata_basic.site_address.address.placeId
            ? formdata_basic.site_address.address.placeId
            : "",
          address1: formdata_basic.site_address.address.name,
          postcode: formdata_basic.site_address.pincode,
          id_country: formdata_basic.site_address.place_details.id_country,
          country_iso_code: (this as any).countryCode,
        };

        let current_address = null;
        if (formdata_basic.current_address) {
          current_address = {
            address_type: "current_address",
            place_id: formdata_basic.current_address.checkBox
              ? site_address.place_id
              : formdata_basic.current_address.address.placeId
              ? formdata_basic.current_address.address.placeId
              : "",
            address1: formdata_basic.current_address.checkBox
              ? site_address.address1
              : formdata_basic.current_address.address.name,
            postcode: formdata_basic.current_address.checkBox
              ? site_address.postcode
              : formdata_basic.current_address.pincode,
            country_iso_code: formdata_basic.current_address.checkBox
              ? site_address.country_iso_code
              : (this as any).countryCode,
          };
        }

        (this as any).$store.commit("appModule/storeProjectAddress", {
          site_address: site_address,
          current_address: current_address,
        });
        delete formdata_basic.current_address;
        delete formdata_basic.site_address;
        return (this as any).createLead(formdata_basic);
      } else {
        return Promise.resolve();
      }
    },
    handleWithDecorationAction(
      asyncFunc: (...args: any) => Promise<any>,
      button: { disabled: boolean }
    ) {
      button.disabled = true;
      return asyncFunc
        .apply(arguments)
        .then((response: any) => {
          button.disabled = false;
          return response;
        })
        .catch((err: any) => {
          button.disabled = false;
          (this as any).$store.commit("uiModule/hideLoadingModal", null, {
            root: true,
          });
          (this as any).$store.dispatch("uiModule/addToast", {
            severity: "error",
            message: getErrorMsg(err),
          });
          throw err;
        });
    },
    setDisabledUserInfo(disabledState: boolean) {
      (this as any).isUserDisabled = disabledState;
      if ((this as any).isUserDisabled) {
        (this as any).$store.dispatch("uiModule/addToast", {
          severity: "error",
          duration: 0,
          message:
            "You are not part of any EC so you cannot create new Project.",
        });
      } else {
        (this as any).modalElement = Object.assign((this as any).modalElement, {
          isVisible: false,
          isClosable: false,
          type: "",
          content: "",
        });
      }
    },
  },
  mounted() {
    (this as any).$store.commit(
      "uiModule/setUniqueSegmentKey",
      new Date().toJSON(),
      {
        root: true,
      }
    );
    (this as any).isProjectAlreadyExist = false;
    (this as any)
      .getFormStructureSchema("customer_basic")
      .then((response: any) => {
        (this as any).basicDetailFormStructure = response;
      })
      .catch((err: any) => {
        throw err;
      });
    if (!(this as any).selectedEc) {
      // (this as any).setDisabledUserInfo(true);
      (this as any)
        .handleWithDecorationAction(
          (this as any).getEcInfoOfUser,
          (this as any).saveBtn
        )
        .then(() => {
          (this as any).setDisabledUserInfo(false);
        })
        .catch((err: any) => {
          (this as any).setDisabledUserInfo(true);
        });
    }
  },
  watch: {
    selectedEc(newVal) {
      // Disable (and show the "not part of any EC" toast) only when there is
      // no EC selected. Note: selectedEc.name carries the EC id (see
      // transformEcResponse), so it is truthy for any valid EC.
      (this as any).setDisabledUserInfo(!(newVal && newVal.name));
    },
  },
});
